import {FC, useState, useMemo} from 'react'
import {get} from 'lodash'
import {useSelector} from 'hooks/redux'
import {isAdminSelector, isOfficeAdminSelector} from 'libs/redux'
import {procedureCategories, procedureTypes} from 'features/procedures/procedureTypes'
import {FlatCard, FlatCardBody, FlatCardHeader, FlatCardTitle} from '../FlatCard'
import {ProcedureCategoryTab} from './ProcedureCategoryTab'
import {ProcedureCategoryTabs} from './ProcedureCategoryTabs'
import styles from './Procedures.scss'
import {Link} from 'react-router-dom'

export const Procedures: FC = () => {
  const currentUser = useSelector((state) => state.session.currentUser)
  const isAdmin = useSelector(isAdminSelector)
  const isOfficeAdmin = useSelector(isOfficeAdminSelector)
  const [currentCategory, setCurrentCategory] = useState<string>()

  const availableProcedureTypes = useMemo(
    () =>
      procedureTypes.filter(
        (pt) =>
          get(currentUser, `client_role.client_role_permissions.${pt.procedureType}.creatable`) && // use _.get because suppress type check error
          !(isOfficeAdmin && pt.procedureType === 'change_office') && // FIXME: この条件はclient_role_permissionsで判定できるので不要という疑惑がある
          (isAdmin || currentUser.employee?.gender === 'woman' || pt.procedureType !== 'maternity_leave')
      ),
    [currentUser, isAdmin, isOfficeAdmin]
  )

  const availableCategories = useMemo(() => {
    const categories = new Set(availableProcedureTypes.map((pt) => pt.category))
    return procedureCategories.filter((c) => categories.has(c.category))
  }, [availableProcedureTypes])

  const currentCategoryOrDefault = currentCategory || availableCategories[0]!.category
  const currentProcedureTypes = availableProcedureTypes.filter((pt) => pt.category === currentCategoryOrDefault)

  return (
    <FlatCard>
      <FlatCardHeader>
        <FlatCardTitle>手続きの開始</FlatCardTitle>
      </FlatCardHeader>
      <FlatCardBody>
        <ProcedureCategoryTabs>
          {availableCategories.map((category) => (
            <ProcedureCategoryTab
              key={category.category}
              category={category}
              active={category.category === currentCategoryOrDefault}
              onClick={() => setCurrentCategory(category.category)}
            />
          ))}
        </ProcedureCategoryTabs>
        <div className={styles.tabContainer}>
          <div className={styles.procedureList}>
            {currentProcedureTypes.map((pt) => (
              <Link
                key={pt.procedureType}
                className={styles.procedure}
                to={`${!isAdmin && pt.supportsMypagePrefix ? '/mypage/' : '/'}${pt.procedureType}`}
              >
                <span className={styles.procedureTitle}>{pt.title}</span>
                <span className={styles.procedureDescription}>{pt.description}</span>
              </Link>
            ))}
          </div>
        </div>
      </FlatCardBody>
    </FlatCard>
  )
}
